import React, { SVGProps } from 'react';

import { BsFillPhoneFill } from 'react-icons/bs';
import { FaCouch, FaCar } from 'react-icons/fa';
import { HiCake } from 'react-icons/hi';
import { RiBuilding2Fill } from 'react-icons/ri';

import { TkT } from './icons';

const PATTERN_ICON_SIZE = 30;
interface PatternProps extends SVGProps<SVGElement> {
  /**
   * Pattern icon size
   * @default 30
   */
  size?: number;
  /**
   * Spacing between icons
   * @default 30
   */
  spacing?: number;
}
const Pattern: React.FC<PatternProps> = ({
  size = PATTERN_ICON_SIZE,
  spacing = size,
}) => (
  <svg width="100%" height="100%" fill="currentColor">
    {/* pattern definition */}
    <pattern
      id="pattern-shapes"
      x="0"
      y="0"
      width={spacing * 6}
      height={spacing * 4}
      patternUnits="userSpaceOnUse"
    >
      {/* Icons to be used in the pattern along with the spacing */}
      <TkT x={spacing} size={size} />
      <HiCake x={spacing * 3} y={0} size={size} />
      <BsFillPhoneFill x={spacing * 5} y={0} size={size} />
      <RiBuilding2Fill x={0} y={spacing * 2} size={size} />
      <FaCouch x={spacing * 2} y={spacing * 2} size={size} />
      <FaCar x={spacing * 4} y={spacing * 2} size={size} />
    </pattern>
    {/* The canvas with our applied pattern */}
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      fill="url(#pattern-shapes)"
    ></rect>
  </svg>
);

export default Pattern;
